export default __webpack_public_path__ + "static/media/pilz-08.78005464.png";